export default "__VITE_ASSET__BB8d_XM9__"